import { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { api } from '../../services/api'
import './ChangePassword.css'
import { MainLayout } from '../../Layout/MainLayout'
import { useAuth } from '../../context/AuthContext'


export function ChanegePassword() {
    const navigate = useNavigate()
    const [loading, setLoading] = useState(false)
    const [success, setSuccess] = useState(false)
    const [error, setError] = useState('')
    const user = useAuth()

    const userId = user.user?.id
    const [form, setForm] = useState({
        oldPassword: '',
        newPassword: '',
    })

    function set(field: string, value: string) {
        setForm(prev => ({ ...prev, [field]: value }))
        setError('')
    }

    function validate() {
        if (!form.oldPassword.trim()) return 'Senha antiga é obrigatório'
        if (!form.newPassword.trim()) return 'Senha nova é obrigatório'
        return null
    }

    async function handleSubmit() {
        const err = validate()
        if (err) { setError(err); return }

        setLoading(true)
        setError('')
        try {
            await api.put(`user/${userId}/update-password`, {
                oldPassword: form.oldPassword,
                newPassword: form.newPassword,
            })
            setSuccess(true)
            setTimeout(() => navigate('/catalogo'), 1800)
        } catch (e: any) {
            setError(e.response?.data?.message || 'Erro ao Atualizar senha')
        } finally {
            setLoading(false)
        }
    }

    if (success) return (
        <MainLayout>
            <div className="cu-success-wrap">
                <div className="cu-success-icon">✓</div>
                <h2 className="serif">Senha Atualizada!</h2>
                <p>Redirecionando para o painel...</p>
            </div>
        </MainLayout>
    )

    return (
        <MainLayout>
            <div className="container fade-in">
                <div className="breadcrumb">
                    <a onClick={() => navigate('/catalogo/')}>Catálogo</a>
                    <span className="sep">›</span>
                    <span>Atualizar Senha</span>
                </div>

                <div className="cu-layout">
                    <div className="cu-header">
                        <div className="kicker">Gestão de Dados</div>
                        <h1 className="serif">Atualizar Senha</h1>
                        <p>a senha deve ter no minimo 8 caracteres.</p>
                    </div>

                    <div className="cu-form-card">
                        {error && <div className="cu-error">{error}</div>}

                        <div className="cu-section-label">Senhas</div>
                        <div className="cu-row">
                            <div className="field" style={{ flex: 1 }}>
                                <label>Senha antiga *</label>
                                <input
                                    type="text"
                                    value={form.oldPassword}
                                    onChange={e => set('oldPassword', e.target.value)}
                                    placeholder="Senha antiga"
                                />
                            </div>
                            <div className="field" style={{ flex: 1 }}>
                                <label>Nova Senha *</label>
                                <input
                                    type="text"
                                    value={form.newPassword}
                                    onChange={e => set('newPassword', e.target.value)}
                                    placeholder="Nova Senha"
                                    autoFocus
                                />
                            </div>
                        </div>

                        <div className="cu-actions">
                            <button
                                className="btn btn-ghost"
                                onClick={() => navigate('/admin')}
                                disabled={loading}
                            >
                                Cancelar
                            </button>
                            <button
                                className="btn btn-primary"
                                onClick={handleSubmit}
                                disabled={loading}
                            >
                                {loading ? 'Criando...' : 'Atualizar →'}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </MainLayout>
    )
}